import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import { CheckboxInputLarge } from 'Packages/FacetDesign/Components/CheckboxInput';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

const ACHTransferTemplateOverride = resource => fr.metaOverride({ base: BaseOverride })
  .typeOverride('bool', { _component: () => CheckboxInputLarge }, overrideReadOnly)
  .nameOverride('amount', {
    ordinal: 1,
  })
  .nameOverride('fullLiquidation', {
    ordinal: 0,
  })
  .nameOverride('endByDate', {
    hidden: () => {
      return resource.attr('frequency') === 'one-time';
    },
    _customHelperProps: {
      helperText: 'Optional - If left blank transfer will continue until canceled.',
    },
  })
  .nameOverride('acknowledgementOfTaxInformation', {
    _customHelperProps: {
      helperText: '', // Don't show error helper text. It doesn't make sense for this field or look good.
    },
  });

export const TransferRolloverAdditionalInstructionsOverride = () => fr.metaOverride({ base: BaseOverride })
  .nameOverride('additionalInstructions', {
    ordinal: 1,
    override: { },
    rows: 10,
    rowsMax: 20,
  });

export default ACHTransferTemplateOverride;
